//
// locales/glitch/en.js
// automatically generated by generateLocalePacks.js
//

import inherited from '../../../app/javascript/mastodon/locales/en.json';
import messages from '../../../app/javascript/flavours/glitch/locales/en.json';
import localeData from 'react-intl/locale-data/en.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages: Object.assign({}, inherited, messages),
});
